__turbopack_context__.v({
  "backdrop": "sidebarList-module-scss-module__a8HxBa__backdrop",
  "backdrop-show": "sidebarList-module-scss-module__a8HxBa__backdrop-show",
  "container": "sidebarList-module-scss-module__a8HxBa__container",
  "fade-in-ux308ha": "sidebarList-module-scss-module__a8HxBa__fade-in-ux308ha",
  "separator": "sidebarList-module-scss-module__a8HxBa__separator",
  "sideBar-item-button": "sidebarList-module-scss-module__a8HxBa__sideBar-item-button",
  "sideBar-item-button-show": "sidebarList-module-scss-module__a8HxBa__sideBar-item-button-show",
  "sideBar-item-container": "sidebarList-module-scss-module__a8HxBa__sideBar-item-container",
  "sideBar-item-container-disabled": "sidebarList-module-scss-module__a8HxBa__sideBar-item-container-disabled",
  "sideBar-item-container-selected": "sidebarList-module-scss-module__a8HxBa__sideBar-item-container-selected",
  "sideBar-item-mobile-container": "sidebarList-module-scss-module__a8HxBa__sideBar-item-mobile-container",
  "sideBar-item-mobile-disabled": "sidebarList-module-scss-module__a8HxBa__sideBar-item-mobile-disabled",
  "sideBar-item-mobile-enabled": "sidebarList-module-scss-module__a8HxBa__sideBar-item-mobile-enabled",
  "sideBar-item-mobile-icon": "sidebarList-module-scss-module__a8HxBa__sideBar-item-mobile-icon",
  "sideBar-item-name": "sidebarList-module-scss-module__a8HxBa__sideBar-item-name",
  "wrapper": "sidebarList-module-scss-module__a8HxBa__wrapper",
});
